import { Gallery, Item } from 'react-photoswipe-gallery';
import Video from "../../../../src/components/Video";
import * as React from 'react';
export default {
  Gallery,
  Item,
  Video,
  React
};